import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { StockMaxMinImportModel } from 'src/app/models/imports/StockMaxMinImportModel';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { StockMaxMinService } from 'src/app/services/inventory/stock-max-min.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-import-stock-max-min',
  templateUrl: './import-stock-max-min.component.html',
  styleUrls: ['./import-stock-max-min.component.scss'],
  standalone: false
})
export class ImportStockMaxMinComponent {

  errorStockMaxMin: number = 0;
  eventFile: any;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  stockMaxMinAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  stockMaxMinImport: boolean = false;
  visibleTxt: boolean = false;

  constructor(
    private stockMaxMinService: StockMaxMinService,
    private toastHandlerService: ToastHandlerService,
    @Inject(PLATFORM_ID) private platformId: object,
    @Optional() private ref: DynamicDialogRef
  ) { }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.stockMaxMinImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.stockMaxMinService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaTopesMaximosMinimos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.stockMaxMinAlerts || this.stockMaxMinAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.stockMaxMinService.exportImportErrors(this.stockMaxMinAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionTopesMaxMin_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  importStockMaxMin() {
    this.stockMaxMinAlerts = [];
    this.errorStockMaxMin = 0;
    this.visibleTxt = false;
    //Validación para ejecutar el código cuando la plataforma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<StockMaxMinImportModel>();
      let row: StockMaxMinImportModel;
      let counter: number = 1, inventoryCode: number, branchCode: number, storeCode: number, articleCode: number, stockMin: number, stockMax: number,
        storeLocation: string | null;

      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: "El archivo ingresado no tiene registros para importar"
            });
            return;
          }
          rows.splice(0, 1);
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            //A. Código Inventario.
            inventoryCode = parseFloat(element[0] as string);
            if (isNaN(inventoryCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna A.  El código del inventario no es válido.`;
              this.stockMaxMinAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Sucursal.
            branchCode = parseFloat(element[1] as string);
            if (isNaN(branchCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna B.  El código de la sucursal no es válido.`;
              this.stockMaxMinAlerts.push(alert);
              rowHasError = true;
            }

            //C. Código Bodega.
            storeCode = parseFloat(element[2] as string);
            if (isNaN(storeCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna C.  El código de la bodega no es válido.`;
              this.stockMaxMinAlerts.push(alert);
              rowHasError = true;
            }

            //D. Código Artículo.
            articleCode = parseFloat(element[3] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna D.  El código del artículo no es válido.`;
              this.stockMaxMinAlerts.push(alert);
              rowHasError = true;
            }

            //E. Stock Mínimo.
            stockMin = parseFloat(element[4] as string);
            if (isNaN(stockMin)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna E. El tope mínimo no es válido.`;
              this.stockMaxMinAlerts.push(alert);
              rowHasError = true;
            }

            //F. Stock Máximo.
            stockMax = parseFloat(element[5] as string);
            if (isNaN(stockMax)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}. Columna F. El tope máximo no es válido no es válido.`;
              this.stockMaxMinAlerts.push(alert);
              rowHasError = true;
            }

            //G. Ubicación Almacén.
            storeLocation = element[6] as string;
            if (storeLocation != null && storeLocation.length > 25) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna G. La ubicación del almacén supera el tamaño máximo de caracteres (25).`;
              this.stockMaxMinAlerts.push(alert);
              rowHasError = true;

            }

            if (!rowHasError) {
              row = new StockMaxMinImportModel(counter, inventoryCode, branchCode, storeCode, articleCode, stockMin, stockMax, storeLocation);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.stockMaxMinService.importStockMaxMin(rowsImports));
              this.loadPreInvoicingModel = response;
              this.stockMaxMinAlerts = response?.alerts ?? [];
              this.errorStockMaxMin = response?.preInvoicingStateId;

              if (this.errorStockMaxMin === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.stockMaxMinAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.stockMaxMinImport = true;
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Topes Máximos-Mínimos.', error);
            }
          } else {
            this.errorStockMaxMin = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No ha seleccionado ningún archivo.'
        });
      }
    }
  }
}